import type { EventsView } from './events-view.js';
import { EVENTS_VIEWS } from './events-views.js';

export function isEventsView(value: unknown): value is EventsView {
  return (EVENTS_VIEWS as readonly unknown[]).includes(value);
}
